var _style, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#F0F0F0;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.8,122.4c-2.3,11-3.3,22.8-3.3,34.5c0,67.5,40.3,126,98,152.3c3.6-17.2,5.6-35,5.6-53.2 C512,114.6,397.4,0,256,0S0,114.6,0,256s114.6,256,256,256c87.7,0,165.1-44.1,211.2-111.3H144.7v-33.4h341.9 c3.5-7.2,6.7-14.7,9.5-22.3H144.7L411.8,122.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.1,133.6l5.5,17h17.9L197,161.1l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L188.1,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.4,256l6.9,21.3h22.3l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.3L115.4,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.4,77.9l6.9,21.3h22.3l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3L86.2,99.2h22.3L115.4,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,178.1l6.9,21.3H89L71,212.5l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.3L59.8,178.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.eb3d690747f6b4df1f0856c3d9505a65.svg";
export { ForwardRef as ReactComponent };